import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import GamifiedButton from '../components/common/GamifiedButton';
import { useLang } from '../i18n/LanguageContext';

export default function NotFound() {
  const { t } = useLang();

  return (
    <div className="not-found-page">
      <SEO
        title={t('regles.introuvable.seoTitre')}
        description={t('regles.introuvable.seoDescription')}
        url="/404"
        keywords="404, page non trouvée, erreur"
        noindex
      />

      <div className="not-found__container">
        <div className="not-found__content">
          <div className="not-found__icon">🎮</div>
          <h1 className="not-found__title">{t('regles.introuvable.titre')}</h1>
          <p className="not-found__subtitle">{t('regles.introuvable.sousTitre')}</p>
          
          <div className="not-found__decoration">
            <span className="not-found__deco-emoji">🧩</span>
            <span className="not-found__deco-emoji">✨</span>
            <span className="not-found__deco-emoji">🎲</span>
          </div>

          <p className="not-found__text">
            {t('regles.introuvable.texte')}
          </p>

          <div className="not-found__actions">
            <Link to="/">
              <GamifiedButton variant="primary" size="lg">
                {t('regles.introuvable.boutonAccueil')}
              </GamifiedButton>
            </Link>
            <Link to="/shop">
              <GamifiedButton variant="secondary" size="lg">
                {t('regles.introuvable.boutonBoutique')}
              </GamifiedButton>
            </Link>
          </div>

          <p className="not-found__help">
            {t('regles.introuvable.aide')}{' '}
            <Link to="/contact" className="not-found__link">{t('regles.introuvable.aideLien')}</Link>
          </p>
        </div>
      </div>

      <style>{`
        .not-found-page {
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 100vh;
          padding: 20px;
          background: linear-gradient(135deg, #FFFFFF 0%, #F7F4EC 100%);
        }

        .not-found__container {
          text-align: center;
          max-width: 600px;
        }

        .not-found__content {
          display: flex;
          flex-direction: column;
          gap: 24px;
        }

        .not-found__icon {
          font-size: 80px;
          display: inline-block;
          animation: float-gentle 2s ease-in-out infinite;
        }

        .not-found__title {
          margin: 0;
          font-size: 48px;
          font-weight: 900;
          color: #33403B;
          font-family: 'Fredoka', 'Poppins', sans-serif;
        }

        .not-found__subtitle {
          margin: 0;
          font-size: 20px;
          color: #2F7E72;
        }

        .not-found__decoration {
          display: flex;
          justify-content: center;
          gap: 16px;
          margin: 20px 0;
        }

        .not-found__deco-emoji {
          font-size: 32px;
          display: inline-block;
          animation: float-gentle 2s ease-in-out infinite;
        }

        .not-found__deco-emoji:nth-child(2) {
          animation-delay: 0.2s;
        }

        .not-found__deco-emoji:nth-child(3) {
          animation-delay: 0.4s;
        }

        .not-found__text {
          margin: 0;
          font-size: 16px;
          line-height: 1.6;
          color: #33403B;
        }

        .not-found__actions {
          display: flex;
          gap: 12px;
          justify-content: center;
          flex-wrap: wrap;
          margin: 20px 0;
        }

        .not-found__actions a {
          text-decoration: none;
        }

        .not-found__help {
          margin: 0;
          font-size: 14px;
          color: #2F7E72;
        }

        .not-found__link {
          color: #4AA294;
          font-weight: 600;
          text-decoration: none;
          border-bottom: 2px solid #4AA294;
          transition: all 0.3s ease;
        }

        .not-found__link:hover {
          color: #E1A72E;
          border-bottom-color: #E1A72E;
        }

        @keyframes float-gentle {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }

        @media (max-width: 768px) {
          .not-found__title {
            font-size: 36px;
          }

          .not-found__subtitle {
            font-size: 18px;
          }

          .not-found__icon {
            font-size: 60px;
          }

          .not-found__actions {
            flex-direction: column;
          }

          .not-found__actions a {
            width: 100%;
          }
        }
      `}</style>
    </div>
  );
}
